import { DeeplinkLoggerEventName } from '@/constants/logs/deeplink';
import { useAirbridgeDynamicLink } from '@/shared/hooks';

export type TrackingInfo = {
  campaign?: string;
  contentId?: string;
  contentTitle?: string;
  contentCategory?: string;
  contentSubCategory?: string;
};

type AppInstallBannerProps = {
  headText: string;
  mainTextRows: string[];
  trackingInfo?: TrackingInfo;
};

const AppInstallBanner = ({ headText, mainTextRows, trackingInfo }: AppInstallBannerProps) => {
  const { contentCategory, contentId, contentTitle, campaign, contentSubCategory } = trackingInfo ?? {};
  const airbridgeDynamicLink = useAirbridgeDynamicLink();

  const onClickInstallApp = () => {
    airbridgeDynamicLink.navigateWithTracking(DeeplinkLoggerEventName.ClickCtaButton, {
      campaign: campaign,
      content: 'web_bottom_bnr_details',
      term: '지금 앱으로 진료받기',
      sub_id: contentId,
      sub_id_1: contentTitle,
      sub_id_2: contentCategory,
      ...(contentSubCategory && { sub_id_3: contentSubCategory }),
    });
  };

  return (
    <div className='flex w-full flex-col items-center gap-[26px] bg-primary-100 px-6 py-10'>
      <div className='flex flex-col items-center gap-1'>
        <span className='typography-ui-19sb text-gray-700'>{headText}</span>
        <div className='typography-ui-28b flex flex-col items-center text-primary-700'>
          {mainTextRows.map((text, index) => {
            return <span key={index}>{text}</span>;
          })}
        </div>
      </div>
      <div className='flex flex-col items-center'>
        <div className='w-[178px] overflow-hidden rounded-[20px] bg-gray-30 p-1'>
          <img className='mb-[-25px] w-full rounded-lg' src='/images/qna/appHomeScreen.png' alt='app_home_screen' />
        </div>
        <button
          className='typography-ui-17sb h-14 w-60 rounded-lg bg-primary-600 px-3 text-white'
          onClick={onClickInstallApp}
        >
          지금 앱으로 진료받기
        </button>
      </div>
    </div>
  );
};

export default AppInstallBanner;
